<script setup>
// *************************************
// *****                           *****
// *****  TheFooter.vue：フッター  *****
// *****  Changed                  *****
// *****  by R.Komatsu 2026/03/10  *****
// *****                           *****
// *************************************
import { onMounted, ref } from 'vue'
const visible = ref(true)
const env_name = `${process.env.VUE_APP_MODE!='staging' ?'' :'検証'}`
const toggle = () => {
	visible.value = !visible.value
}
</script>

<template>
<footer v-if="visible" class="footer" @dblclick="toggle">
  <p>Copyright © 2024 RFJ CO., Ltd. All rights reserved.
  {{ env_name }}</p>
</footer>
</template>

<style scoped>
.footer {
  font-size: 11px;
  color: white;
  background-color: #333;
  text-align: center;
  padding: 0 0 0 0;
  //box-shadow: 0 -1px 5px rgba(0,0,0,0.1);
}
</style>
